/* Carrito lateral propio (ajuste lp_cart). Contrato y porqués: sections/lp-cart.liquid. Aquí no se formatea dinero ni se hacen cuentas. */
(() => {
  const dlg = document.getElementById('lp-cart');
  if (!dlg || !dlg.showModal) return;
  const S = 'lp-cart';
  const base = (window.routes && routes.cart_url) || '/cart';
  const q = (s) => dlg.querySelector(s);
  const err = q('[data-lp-cart-error]');
  const live = q('[data-lp-cart-live]');
  let busy = false;
  let opener = null;

  // «Combina con» (ADR-0028; 28-10-2026: hasta data-max, en lista vertical). La sección da las candidatas ya ordenadas (data-src: first = fijas, rec = recomendaciones de Shopify,
  // fill = relleno de la tienda) con su precio formateado (/recommendations/products?section_id=lp-cart); aquí solo se filtra el DOM: fuera lo que ya está en el carrito y los repetidos,
  // y se corta a data-max. Sin regla de tipo. Si las fijas y las complementarias no llegan, se piden también las relacionadas, que van detrás de ellas y delante del relleno.
  const recsUrl = `${window.Shopify?.routes?.root || '/'}recommendations/products`;
  const asked = new WeakSet();
  let recsN = 0;
  const recs = async (slot) => {
    if (!slot) return;
    asked.add(slot);
    const n = ++recsN;
    const { have, for: last } = slot.dataset;
    const mine = new Set(have.split(','));
    const get = async (intent) => {
      try {
        const r = await fetch(`${recsUrl}?section_id=${S}&product_id=${last}&limit=10&intent=${intent}`);
        return r.ok ? new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-lp-recs]') : null;
      } catch (e) {
        return null;
      }
    };
    const boxes = [];
    const order = () => {
      const seen = new Set(mine);
      const all = boxes.flatMap((b) => [...b.querySelectorAll('[data-pid]')]);
      return ['first', 'rec', 'fill']
        .flatMap((src) => all.filter((li) => (li.dataset.src || 'fill') === src))
        .filter((li) => !seen.has(li.dataset.pid) && seen.add(li.dataset.pid));
    };
    const first = await get('complementary');
    if (first) boxes.push(first);
    const max = Number(first?.dataset.max) || 4;
    if (order().filter((li) => li.dataset.src !== 'fill').length < max) {
      const rel = await get('related');
      if (rel) boxes.push(rel);
    }
    const box = boxes[0];
    const list = order().slice(0, Number(box?.dataset.max) || max);
    if (n !== recsN || !slot.isConnected) return;
    if (!list.length) return slot.replaceChildren();
    box.querySelector('ul').replaceChildren(...list);
    if (!slot.firstElementChild && !still) box.classList.add('is-in'); // la entrada escalonada, solo la primera vez que sale (no en los refrescos)
    slot.replaceChildren(box);
  };

  // Cuerpo nuevo; número de la cabecera; foco al mismo control de la misma línea (o al primero).
  // keep = el hueco de «Combina con» donde se acaba de pulsar «+ Añadir»: se conserva un instante para que se vea «✓ Añadido» (joy lo recarga después)
  const paint = (html, keep, quiet) => {
    const body = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lp-cart-body]');
    const old = q('[data-lp-cart-body]');
    if (!body || !old) return false;
    const prev = snap(old);
    const f = document.activeElement;
    const inside = old.contains(f);
    const key = inside && f.closest('[data-lp-cart-line]')?.dataset.lpCartLine;
    const gw = inside && f.closest('[data-lp-gift-pick]'); // foco dentro de la elección del regalo: se devuelve al repintar
    const gk = gw && { key: gkey(gw), tier: gw.dataset.tier };
    giftSave(old);
    old.replaceWith(body);
    giftInit(body);
    if (!quiet) life(body, prev);
    const slot = body.querySelector('[data-lp-recs-slot]');
    if (keep && slot) {
      Object.assign(keep.dataset, slot.dataset);
      slot.replaceWith(keep);
    } else if (slot && dlg.open) recs(slot);
    const { count, label } = body.dataset;
    document.querySelectorAll('[data-cart-count]').forEach((n) => {
      n.textContent = count;
      n.hidden = count === '0';
    });
    document.querySelectorAll('[data-cart-label]').forEach((n) => (n.textContent = label));
    if (inside) {
      const l = [...body.querySelectorAll('[data-lp-cart-line]')].find((x) => x.dataset.lpCartLine === key);
      const w = gk && ([...body.querySelectorAll('[data-lp-gift-pick]')].find((x) => gkey(x) === gk.key) || [...body.querySelectorAll('[data-lp-gift-pick]')].find((x) => x.dataset.tier === gk.tier));
      if (w) (w.classList.contains('is-open') ? w.querySelector('.lp-gift__panel') : w.querySelector('[data-lp-gift-open]')).focus({ preventScroll: true });
      else if (keep?.isConnected && keep.contains(f)) f.focus({ preventScroll: true });
      else (l?.querySelector(`[name="${f.name}"]:enabled`) || l?.querySelector('button:enabled') || q('button')).focus();
    }
    live.textContent = '';
    // Con subida a pack a la vista (ADR-0028), se lee también su frase (viene hecha de la sección)
    const offer = body.querySelector('[data-lp-cart-offer]');
    setTimeout(() => (live.textContent = offer?.dataset.live ? `${label}. ${offer.dataset.live}` : label), 150);
    return true;
  };

  const refresh = () =>
    fetch(`${location.pathname}?sections=${S}`)
      .then((r) => r.json())
      .then((j) => paint(j[S], null, true))
      .catch(() => {});

  const post = (url, data) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...data, sections: S, sections_url: location.pathname }),
    }).then(async (r) => {
      const j = await r.json();
      if (!r.ok) throw j;
      return j;
    });

  const open = (from) => {
    if (dlg.open) return;
    opener = from;
    dlg.showModal();
    const slot = q('[data-lp-recs-slot]');
    if (slot && !asked.has(slot)) recs(slot);
  };

  // Barra pegada arriba (29-10-2026, 3.ª versión): la tira de arriba (.lp-bar__top: mensaje + barra) es sticky y el resto de la tarjeta (.lp-bar__more) va en el flujo y se va con el scroll. Al bajar más de 28 px
  // dentro del carrito, .lp-bar pasa a .is-slim, que solo cambia el aspecto de la tira (borde, esquinas, sombra: nada de alto, así el contenido no se mueve); por debajo de 10 px vuelve a como estaba.
  // El scroll no sube por el DOM, así que se escucha en captura sobre el <dialog>: sobrevive a los repintados del cuerpo (el cuerpo nuevo llega arriba y sin .is-slim).
  // Listener pasivo y con un solo trabajo por frame: el evento solo pide un rAF; en él se lee scrollTop una vez y se escribe la clase como mucho una vez (histéresis 28 / 10 px: sin parpadeo cerca del umbral).
  const tall = matchMedia('(min-height: 700px)');
  let slimRaf = 0;
  dlg.addEventListener(
    'scroll',
    (e) => {
      const sc = e.target;
      if (slimRaf || !sc.classList?.contains('lp-cart__scroll')) return;
      slimRaf = requestAnimationFrame(() => {
        slimRaf = 0;
        const bar = sc.querySelector('.lp-bar');
        if (!bar) return;
        const y = sc.scrollTop;
        const on = bar.classList.contains('is-slim');
        if (!on && y > 28 && tall.matches) bar.classList.add('is-slim');
        else if (on && y < 10) bar.classList.remove('is-slim');
      });
    },
    { capture: true, passive: true }
  );

  // Dopamina al añadir (solo transform y opacity): el botón dice «Añadido» un instante, el icono del carrito rebota y salen unas brasas del botón.
  // Va después de abrir el carrito y no espera a nada; con «reducir movimiento» solo cambia el texto.
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Vida del carrito (29-10-2026). Se pinta en cada cambio (paint) y nunca al cargar la página ni al reabrir el carrito; con «reducir movimiento», nada de esto corre.
  // La sección ya trae la barra en su estado final (data-tier 0-3, data-f = relleno en milésimas, data-need/data-span = lo que falta y el tramo, en céntimos); aquí solo se anima de lo que había a lo que hay:
  // el relleno (transición de la variable --f), la cifra «Te faltan X» (cuenta hasta el valor nuevo) y, al cruzar un hito hacia arriba, mensaje, ráfaga de confeti desde ese hito y vibración.
  // Ni cuentas de dinero ni de regalo: los números vienen hechos. El último nivel enseñado se guarda en sessionStorage para no repetir la fiesta.
  const SK = 'lp-bar-tier';
  const mem = (v) => {
    try {
      if (v === undefined) return Number(sessionStorage.getItem(SK)) || 0;
      sessionStorage.setItem(SK, v);
    } catch (e) {}
    return 0;
  };
  const snap = (root) => {
    const d = root?.querySelector('[data-lp-bar]')?.dataset;
    return {
      tier: d ? Number(d.tier) : 0,
      f: d ? Number(d.f) : 0,
      need: d ? Number(d.need) : null,
      keys: new Set([...(root?.querySelectorAll('[data-lp-cart-line]') || [])].map((l) => l.dataset.lpCartLine)),
    };
  };
  mem(String(snap(dlg).tier));
  const tween = (ms, step, done) => {
    const t0 = performance.now();
    const tick = (t) => {
      const k = Math.min(1, (t - t0) / ms);
      step(1 - Math.pow(1 - k, 3));
      if (k < 1) requestAnimationFrame(tick);
      else if (done) done();
    };
    requestAnimationFrame(tick);
  };
  const COLORS = ['#4A2C27', '#7A3626', '#E8A598', '#FAF3EE', '#FFB45A', '#FFB45A'];
  const rnd = (a, b) => a + Math.random() * (b - a);
  const confetti = (dot, n) => {
    if (!dot?.isConnected) return;
    const r = dot.getBoundingClientRect();
    const x0 = Math.round(r.left + r.width / 2);
    const y0 = Math.round(r.top + r.height / 2);
    const bias = x0 > innerWidth * 0.7 ? -0.45 : x0 < innerWidth * 0.3 ? 0.45 : 0;
    const box = document.createElement('div');
    box.className = 'lp-confetti';
    box.setAttribute('aria-hidden', 'true');
    box.setAttribute('popover', 'manual');
    for (let i = 0; i < n; i++) {
      const c = document.createElement('i');
      const up = rnd(50, 150);
      c.style.cssText = `--x0:${x0}px;--y0:${y0}px;--dx:${Math.round((Math.random() * 2 - 1 + bias) * 150)}px;--up:${Math.round(up)}px;--fall:${Math.round(rnd(30, 110))}px;--rot:${Math.round(rnd(-720, 720))}deg;--w:${Math.round(rnd(5, 9))}px;--h:${Math.round(rnd(3, 5))}px;--c:${COLORS[i % COLORS.length]};--br:${i % 3 ? '1px' : '50%'};--dl:${Math.round(rnd(0, 90))}ms`;
      box.appendChild(c);
    }
    document.body.appendChild(box);
    try {
      box.showPopover();
    } catch (e) {}
    setTimeout(() => box.remove(), 1500);
  };
  const life = (body, prev) => {
    const bar = body.querySelector('[data-lp-bar]');
    const tier = bar ? Number(bar.dataset.tier) : 0;
    const was = mem();
    mem(String(tier));
    if (!still) {
      body.querySelectorAll('[data-lp-cart-line]').forEach((l) => {
        if (prev.keys.size === 0 || !prev.keys.has(l.dataset.lpCartLine)) {
          l.classList.add('is-new');
          l.addEventListener('animationend', () => l.classList.remove('is-new'), { once: true });
        }
      });
    }
    if (still || !bar) return;
    const f = Number(bar.dataset.f);
    const need = Number(bar.dataset.need);
    const msg = bar.querySelector('.lp-bar__msg');
    const main = bar.querySelector('.lp-bar__main');
    const fin = main.innerHTML;
    const up = tier > prev.tier && tier > was;
    const delay = dlg.open ? 40 : 380; // cerrado, el carrito se abre justo después: la barra se anima cuando ya se ve
    const gained = up ? Array.from({ length: tier - prev.tier }, (_, i) => prev.tier + i + 1) : [];
    const marks = gained.flatMap((k) => [bar.querySelector(`.lp-bar__dot--${k}`), bar.querySelector(`.lp-bar__mark--${k}`)]).filter(Boolean);
    marks.forEach((m) => m.classList.remove('is-on'));
    if (prev.f !== f) bar.style.setProperty('--f', prev.f);
    msg.setAttribute('aria-live', 'off'); // la cuenta no se anuncia número a número; al acabar se reescribe el texto final
    const end = () => {
      if (!main.isConnected) return;
      msg.removeAttribute('aria-live');
      setTimeout(() => main.isConnected && (main.innerHTML = fin), 60);
    };
    const count = (from, to) => {
      const a = main.querySelector('.lp-bar__amt');
      const m = a && /(\d+)([.,])(\d{2})(?!\d)/.exec(a.textContent);
      if (!m || from == null || from === to || Number.isNaN(from)) return end();
      const t = a.textContent;
      const put = (c) => (a.textContent = t.replace(m[0], `${Math.floor(c / 100)}${m[2]}${String(c % 100).padStart(2, '0')}`));
      put(from);
      tween(700, (k) => a.isConnected && put(Math.round(from + (to - from) * k)), end);
    };
    if (up) {
      main.textContent = bar.getAttribute(`data-cele-${tier}`) || fin;
      msg.classList.add('is-cele');
      bar.classList.add('is-cele');
    }
    setTimeout(() => {
      if (!bar.isConnected) return;
      void bar.offsetWidth;
      bar.style.setProperty('--f', f);
      if (!up) return count(prev.need, need);
      setTimeout(() => {
        marks.forEach((m) => m.classList.add('is-on', 'is-pop'));
        confetti(bar.querySelector(`.lp-bar__dot--${tier}`), tier === 3 ? 40 : 28);
        try {
          navigator.vibrate?.(40);
        } catch (e) {}
      }, 420);
      setTimeout(() => {
        if (!main.isConnected) return;
        msg.classList.remove('is-cele');
        bar.classList.remove('is-cele');
        main.innerHTML = fin;
        count(Number(bar.dataset.span), need);
      }, 2600);
    }, delay);
  };

  const pop = (el, c) => {
    el.classList.remove(c);
    requestAnimationFrame(() => el.classList.add(c));
    setTimeout(() => el.classList.remove(c), 900);
  };
  const joy = (from, rect, keep) => {
    const txt = from.dataset.added || dlg.dataset.added;
    const old = from.innerHTML; // con su marcado: los packs de la tarjeta del catálogo llevan dos líneas (lp-card)
    if (txt) {
      from.textContent = txt;
      from.classList.add('is-added');
      setTimeout(() => {
        from.classList.remove('is-added');
        if (from.textContent === txt) from.innerHTML = old;
        document.getElementById('packs')?.render?.();
        if (keep?.isConnected) recs(keep);
      }, 1700);
    }
    if (still) return;
    document.querySelectorAll('#cart-icon-bubble, [data-cart-count]').forEach((n) => pop(n, 'lp-bump'));
    const r = rect || from.getBoundingClientRect();
    const box = document.createElement('div');
    box.className = 'lp-embers';
    box.setAttribute('aria-hidden', 'true');
    box.setAttribute('popover', 'manual'); // capa superior: por encima del carrito, que también lo es
    // 29-10-2026: saltan más (más alto, más ancho y alguna pieza más); desde «Combina con» (botón dentro del carrito) aún más, para que se vean sobre las tarjetas
    const big = !!rect;
    const n = big ? 28 : 20;
    for (let i = 0; i < n; i++) {
      const b = document.createElement('i');
      b.style.cssText = `left:${r.left + r.width * (0.1 + Math.random() * 0.8)}px;top:${r.top + r.height * 0.4}px;--dx:${Math.round(Math.random() * (big ? 150 : 120) - (big ? 75 : 60))}px;--dy:${Math.round((big ? 110 : 90) + Math.random() * (big ? 170 : 140))}px;--t:${(0.8 + Math.random() * 0.8).toFixed(2)}s;--s:${3 + Math.round(Math.random() * 4)}px`;
      box.appendChild(b);
    }
    document.body.appendChild(box);
    try {
      box.showPopover();
    } catch (e) {}
    setTimeout(() => box.remove(), 1900);
  };

  // Una petición cada vez. Si Shopify dice que no, su texto y el carrito como está
  const run1 = async (req, from) => {
    let ok = false;
    const keep = from?.closest('[data-lp-recs-slot]');
    // Botón dentro del carrito («Combina con» o las mini-tarjetas del carrito vacío): su sitio antes de pintar, porque el cuerpo nuevo puede no tenerlo (3 productos, o ya no vacío)
    const rect = from && dlg.contains(from) ? from.getBoundingClientRect() : null;
    busy = true;
    dlg.setAttribute('aria-busy', 'true');
    err.hidden = true;
    try {
      const j = await req();
      if (!paint(j.sections?.[S], keep)) await refresh();
      ok = true;
    } catch (e) {
      err.textContent = e?.description || dlg.dataset.error;
      err.hidden = false;
      await refresh();
    }
    busy = false;
    dlg.removeAttribute('aria-busy');
    if (!from) return ok;
    open(from);
    // Fuera el «Añadiendo…» de pack-selector.js
    document.querySelectorAll('[data-pack-buy].is-loading').forEach((b) => b.classList.remove('is-loading'));
    document.getElementById('packs')?.render?.();
    if (ok) joy(from, rect, keep);
    return ok;
  };

  // Adaptador de regalo (ADR-0031). Añadir: el botón de añadir del panel de la elección (data-lp-gift = variante elegida, data-tier = tramo) añade 1 unidad con la propiedad oculta _regalo_tramo.
  // Quitar: la sección marca con [data-lp-gift-fix] (clave de línea y data-qty = cantidad que le toca) las líneas del regalo que sobran al bajar del tramo; aquí solo se cambian, de una en una
  // (máximo 4 vueltas por si Shopify se negara), y la sección se vuelve a pintar entre cada una. Las cuentas (tramos, qué sobra) son de la sección, no de aquí.
  const settle = async () => {
    for (let i = 0; i < 4; i++) {
      const fx = q('[data-lp-gift-fix]');
      if (!fx || busy) return;
      // Si Shopify dice que no (429, error), se para: el arreglo se reintenta en el siguiente cambio o al recargar, no en ráfaga
      if (!(await run1(() => post(`${base}/change.js`, { id: fx.dataset.lpGiftFix, quantity: Number(fx.dataset.qty) })))) return;
    }
  };
  const run = async (req, from) => {
    const ok = await run1(req, from);
    await settle();
    return ok;
  };

  // Celebración al conseguir el regalo (29-10-2026): la línea del regalo, recién pintada, recibe un aro cálido (.is-won) y un confeti pequeño sale de su etiqueta «Regalo»; vibración corta.
  // Con «reducir movimiento», nada. Sin cuentas: solo se anima lo que la sección ya pintó.
  const won = () => {
    if (still) return;
    const line = [...dlg.querySelectorAll('[data-lp-cart-gift]')].find((l) => l.classList.contains('is-new')) || dlg.querySelector('[data-lp-cart-gift]');
    if (!line) return;
    line.classList.add('is-won');
    setTimeout(() => line.classList.remove('is-won'), 3200);
    setTimeout(() => {
      confetti(line.querySelector('.lp-cart__price--gift') || line, 22);
      try {
        navigator.vibrate?.(30);
      } catch (e) {}
    }, 260);
  };

  // Elección del regalo (03-11-2026; marcado en snippets/lp-cart-gift.liquid, estilos en lp-global.css «Elección del regalo»). Secuencia: el botón dorado (CSS) → al pulsarlo se abre el panel DEBAJO de la barra (no un desplegable
  // de botones) → la primera vez que se gana cada regalo, la caja se abre (clase .is-playing, ~2 s, solo CSS) y deja ver la foto → se elige color o diseño con pastillas (la foto cambia) → «Añadir» (el mismo camino de siempre,
  // data-lp-gift = variante elegida). Con el regalo ya en el carrito (modo change) el mismo panel cambia el color: se quita la línea y se añade la nueva variante. Sin cuentas: lo que toca ofrecer lo decide la sección.
  // «Una vez por regalo ganado»: sessionStorage guarda qué tramos ya se enseñaron; se olvida el tramo cuando la barra baja de él (y el regalo se quita), así que ganarlo otra vez vuelve a abrir la caja.
  // El estado del panel (abierto, color marcado) sobrevive a los repintados del cuerpo (giftSave/giftInit). Con «reducir movimiento» no hay caja: la foto está ya a la vista.
  const GK = 'lp-gift-seen';
  const seenGet = () => {
    try {
      return new Set((sessionStorage.getItem(GK) || '').split(',').filter(Boolean));
    } catch (e) {
      return new Set();
    }
  };
  const seenPut = (set) => {
    try {
      sessionStorage.setItem(GK, [...set].join(','));
    } catch (e) {}
  };
  const gkey = (w) => `${w.dataset.tier}-${w.dataset.mode}`;
  const gifts = (root) => [...root.querySelectorAll('[data-lp-gift-pick]')];
  const gstate = new Map();
  const giftSave = (root) => {
    gstate.clear();
    gifts(root).forEach((w) => gstate.set(gkey(w), { open: w.classList.contains('is-open'), v: w.querySelector('input:checked')?.dataset.v }));
  };
  const giftPick = (w, input, instant) => {
    w.querySelector('[data-lp-gift-sel]').textContent = input.value;
    const add = w.querySelector('.lp-gift__add');
    add.dataset.lpGift = input.dataset.v;
    if (add.dataset.lpGiftSwap) add.disabled = input.dataset.v === add.dataset.cur; // el mismo color que ya hay: nada que cambiar
    const img = w.querySelector('.lp-gift__img');
    if (!img || !input.dataset.src || img.getAttribute('src') === input.dataset.src) return;
    const put = () => {
      img.srcset = input.dataset.srcset || '';
      img.src = input.dataset.src;
      img.alt = input.dataset.alt || '';
      img.classList.remove('is-out');
    };
    if (instant || still) return put();
    img.classList.add('is-out');
    setTimeout(() => img.isConnected && put(), 170);
  };
  // Móvil (≤ 749 px, 04-11-2026): con un panel de regalo abierto el carrito lleva .is-gift-open y el pie se encoge a una fila (lp-global.css), para que el panel quepa entero; vuelve al cerrarlo o al añadir
  // (el repintado trae el cuerpo nuevo sin panel abierto: giftInit lo sincroniza). Y el cuerpo se desplaza con suavidad (solo el suyo, no los contenedores de fuera) hasta dejar el panel justo debajo de la barra de progreso.
  const phone = matchMedia('(max-width: 749px)');
  const footSync = () => dlg.classList.toggle('is-gift-open', !!dlg.querySelector('.lp-gift.is-open'));
  const toPanel = (panel) => {
    const sc = panel.closest('.lp-cart__scroll');
    if (!sc) return false;
    const bar = sc.querySelector('.lp-bar__top');
    const stuck = bar && getComputedStyle(bar).position === 'sticky'; // la barra solo se pega con 700 px o más de alto
    const top = sc.scrollTop + panel.getBoundingClientRect().top - sc.getBoundingClientRect().top - (stuck ? bar.offsetHeight : 0) - 8;
    sc.scrollTo({ top: Math.max(0, top), behavior: still ? 'auto' : 'smooth' });
    return true;
  };
  const giftOpen = (w, on, quiet) => {
    const panel = w.querySelector('.lp-gift__panel');
    const cta = w.querySelector('[data-lp-gift-open]');
    if (!panel || on === w.classList.contains('is-open')) return;
    cta.setAttribute('aria-expanded', String(on));
    w.classList.toggle('is-open', on);
    if (!on) {
      panel.hidden = true;
      w.classList.remove('is-playing');
      footSync();
      return;
    }
    const seen = seenGet();
    const play = !quiet && !still && w.dataset.mode === 'pick' && !seen.has(w.dataset.tier);
    if (w.dataset.mode === 'pick' && !quiet) {
      seen.add(w.dataset.tier);
      seenPut(seen);
    }
    if (play) w.classList.add('is-playing'); // antes de mostrarlo: la animación arranca en el primer fotograma
    panel.hidden = false;
    footSync();
    if (quiet) return;
    panel.focus({ preventScroll: true });
    if (!(phone.matches && toPanel(panel))) panel.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' });
    if (!play) return;
    setTimeout(() => {
      const st = w.querySelector('.lp-gift__stage');
      if (w.classList.contains('is-playing') && st?.isConnected) {
        confetti(st, 26);
        try {
          navigator.vibrate?.(30);
        } catch (e) {}
      }
    }, 950);
    setTimeout(() => w.classList.remove('is-playing'), 2150);
  };
  const giftInit = (root) => {
    const bar = root.querySelector('[data-lp-bar]');
    const seen = seenGet();
    if (bar) {
      const t = Number(bar.dataset.tier);
      [1, 2].forEach((k) => t < k + 1 && seen.delete(String(k))); // el hito de este regalo ya no se alcanza: la próxima vez vuelve a abrirse la caja
      seenPut(seen);
    }
    gifts(root).forEach((w) => {
      const st = gstate.get(gkey(w));
      const input = st && [...w.querySelectorAll('input')].find((i) => i.dataset.v === st.v);
      if (input && !input.checked) input.checked = true;
      const sel = w.querySelector('input:checked');
      if (sel) giftPick(w, sel, true);
      if (st?.open) giftOpen(w, true, true);
    });
    footSync();
  };
  dlg.addEventListener('change', (e) => {
    const w = e.target.closest?.('[data-lp-gift-pick]');
    if (w && e.target.matches('input[type="radio"]')) giftPick(w, e.target);
  });
  giftInit(dlg);

  // Medición sin apps. Test de regalo (28-10-2026): el botón del resultado lleva data-test-regalo y cada línea que añade sale con la propiedad oculta _test_regalo.
  // Origen (28-10-2026): si el botón está dentro de un [data-lp-origen] (mosaico, packs, test: ajuste «origen» de la sección), cada línea sale también con _origen = ese nombre.
  // Los guiones bajos ocultan las propiedades al cliente. Botón de la pantalla de elegir del pack: el <dialog> está dentro de la sección y su «Añadir» pulsa el botón del pack, así que cuenta lo mismo.
  // Sin atributos, no cambia nada.
  const tagged = (items, from) => {
    const props = {};
    if (from.dataset.testRegalo) props._test_regalo = from.dataset.testRegalo;
    const o = from.closest('[data-lp-origen]')?.dataset.lpOrigen;
    if (o) props._origen = o;
    return Object.keys(props).length ? items.map((it) => ({ ...it, properties: { ...it.properties, ...props } })) : items;
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    const buy = t.closest('[data-pack-buy]');
    // Agotado, «Elegir pack» de la barra o sin líneas: el enlace de siempre
    if (buy?.dataset.packItems && buy.getAttribute('aria-disabled') !== 'true' && !buy.closest('sticky-buy[data-choosing]')) {
      e.preventDefault();
      if (!busy) run(() => post(`${base}/add.js`, { items: tagged(JSON.parse(buy.dataset.packItems), buy) }), buy);
      return;
    }
    // «+» de las tarjetas (lp-card: catálogo y mosaico de la portada) y de las mini-tarjetas del carrito (lp-cart-mini): la variante marcada, una unidad, por el mismo camino
    const add = t.closest('[data-lp-add]');
    if (add) {
      e.preventDefault();
      if (!busy && add.getAttribute('aria-disabled') !== 'true') {
        if (add.closest('[data-lp-recs-slot]')) add.setAttribute('aria-disabled', 'true'); // una pulsación, una unidad
        run(() => post(`${base}/add.js`, { items: tagged([{ id: Number(add.dataset.lpAdd), quantity: 1 }], add) }), add);
      }
      return;
    }
    const go = t.closest('[data-lp-gift-open]');
    if (go) {
      e.preventDefault();
      const w = go.closest('[data-lp-gift-pick]');
      giftOpen(w, !w.classList.contains('is-open'));
      return;
    }
    // Cambiar el regalo ya añadido: se quita su línea (clave en data-lp-gift-swap) y se añade la variante elegida; la petición de añadir va la última y trae la sección ya al día
    const swap = t.closest('[data-lp-gift-swap]');
    if (swap) {
      e.preventDefault();
      if (!busy && !swap.disabled) {
        run(async () => {
          await post(`${base}/change.js`, { id: swap.dataset.lpGiftSwap, quantity: 0 });
          return post(`${base}/add.js`, { items: [{ id: Number(swap.dataset.lpGift), quantity: 1, properties: { _regalo_tramo: swap.dataset.tier } }] });
        }).then((ok) => {
          if (!ok) return;
          const w = dlg.querySelector(`[data-lp-gift-pick][data-tier="${swap.dataset.tier}"]`);
          if (w) giftOpen(w, false); // cambiado: el panel se cierra (el repintado lo habría dejado abierto)
          won();
        });
      }
      return;
    }
    const gift = t.closest('[data-lp-gift]');
    if (gift) {
      e.preventDefault();
      if (!busy) run(() => post(`${base}/add.js`, { items: [{ id: Number(gift.dataset.lpGift), quantity: 1, properties: { _regalo_tramo: gift.dataset.tier } }] })).then((ok) => ok && won());
      return;
    }
    const icon = t.closest('#cart-icon-bubble');
    if (icon) {
      e.preventDefault();
      return open(icon);
    }
    const b = t.closest('[data-lp-cart-qty]');
    const line = b?.closest('[data-lp-cart-line]');
    if (line && !busy) run(() => post(`${base}/change.js`, { id: line.dataset.lpCartLine, quantity: Number(b.dataset.lpCartQty) }));
    if (t === dlg) dlg.close(); // el fondo
  });

  dlg.addEventListener('close', () => {
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  });

  // Página recuperada al volver atrás (del pago): carrito al día
  addEventListener('pageshow', (e) => e.persisted && refresh().then(settle));
  settle(); // carrito recién cargado con un regalo que ya no toca (p. ej. cambió en otra pestaña)
  document.querySelectorAll('#cart-icon-bubble').forEach((a) => a.setAttribute('aria-haspopup', 'dialog'));
})();
